<template>
  <div id="productIndex">
    <NavBar />

    <div id="hero" class="hero overlay subpage-hero">
      <div class="hero-content">
        <div class="hero-text">
          <h1>产品</h1>
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/">首页</router-link>
            </li>
            <li class="breadcrumb-item active">产品</li>
          </ol>
        </div>
        <!-- /.hero-text -->
      </div>
      <!-- /.hero-content -->
    </div>
    <!-- /.hero -->

    <main id="main" class="site-main">
      <section class="site-section subpage-site-section section-portfolio">
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <h2 class="text-center heading-separator">
                以下產品乃屬本公司所擁有
              </h2>
            </div>
          </div>

          <div id="grid" class="row">
            <div
              class="col-lg-3 col-md-4 col-xs-6 mb-4"
              v-for="(productItem, productIndex) in productList"
              :key="productIndex"
            >
              <div class="portfolio-item">
                <img
                  :src="require('@/assets/img/products/' + productItem.img)"
                  class="img-res mx-auto"
                  alt=""
                />
                <h4 class="portfolio-item-title">{{ productItem.title }}</h4>
                <router-link class="text-black" :to="productItem.link">
                  <i class="fa fa-arrow-right" aria-hidden="true"></i>
                </router-link>
              </div>
              <router-link class="text-center" :to="productItem.link">
                <h3 class="mt-2">{{ productItem.title }}</h3>
              </router-link>
              <!-- /.portfolio-item -->
            </div>
          </div>
          <div class="text-center">
            <a class="btn btn-green" href="javascript:;" id="loadMore">加载</a>
          </div>
        </div>
      </section>
      <!-- /.section-portfolio -->
    </main>
    <!-- /#main -->

    <Footer />
  </div>
</template>

<script>
/* eslint-disable */
import NavBar from "../partials/NavBar.vue";
import Footer from "../partials/Footer.vue";

export default {
  name: "ProductIndex",
  data() {
    return {
      productList: [
        {
          img: "huan-zai-jin.jpg",
          title: "還債金",
          link: "/products/huan-zai-jin"
        },
        {
          img: "tai-sui-dian.jpg",
          title: "太歲殿",
          link: "/products/tai-sui-dian"
        },
        {
          img: "di-zhu-jin.jpg",
          title: "地主金",
          link: "/products/di-zhu-jin"
        },
        {
          img: "nan-dou-liu-xing-yan-shou-deng.jpg",
          title: "南斗六星延壽燈",
          link: "/products/nan-dou-liu-xing-yan-shou-deng"
        },
        {
          img: "tai-sui-jin.jpg",
          title: "太歲金",
          link: "/products/tai-sui-jin"
        },
        {
          img: "tian-guan-jin.jpg",
          title: "天官金",
          link: "/products/tian-guan-jin"
        },
        {
          img: "wan-fo-shen-qi-ye.jpg",
          title: "萬佛神奇液",
          link: "/products/wan-fo-shen-qi-ye"
        },
        {
          img: "wan-fo-shen-xiang-you.jpg",
          title: "萬佛神香油",
          link: "/products/wan-fo-shen-xiang-you"
        },
        {
          img: "wen-wu-cai-shen-bao-ku.jpg",
          title: "文武財神寶庫",
          link: "/products/wen-wu-cai-shen-bao-ku"
        },
        {
          img: "shou-sheng-qian.jpg",
          title: "壽生錢",
          link: "/products/shou-sheng-qian"
        },
        {
          img: "wen-chang-jin.jpg",
          title: "文昌金",
          link: "/products/wen-chang-jin"
        },
        {
          img: "zhu-ge-kong-ming-chen-tan-xiang.jpg",
          title: "諸葛孔明沉檀香",
          link: "/products/zhu-ge-kong-ming-chen-tan-xiang"
        },
        {
          img: "3-he-1-da-zhuan-yun-fa.jpg",
          title: "3合1",
          link: "/products/3-he-1-da-zhuan-yun-fa"
        }
      ]
    };
  },
  components: {
    NavBar,
    Footer
  },
  created() {
    $(document).ready(function() {
      //shuffle.js
      var shuffleme = (function($) {
        "use strict";
        var $grid = $("#grid"), //locate what we want to sort
          $filterOptions = $(".portfolio-sorting li"), //locate the filter categories
          init = function() {
            // None of these need to be executed synchronously
            setTimeout(function() {
              //listen();
              setupFilters();
            }, 100);

            $("#grid .col-md-4")
              .slice(0, 4)
              .show();

            $("#loadMore").on("click", function(e) {
              e.preventDefault();
              $("#grid .col-md-4:hidden")
                .slice(0, 4)
                .fadeIn()
                .each(function() {
                  $grid.shuffle("appended", $(this));
                });

              if ($("#grid .col-md-4:hidden").length == 0) {
                $("#loadMore")
                  .addClass("disabled")
                  .html("加载完毕");
              }
            });

            // instantiate the plugin
            $grid.shuffle({
              itemSelector: '[class*="col-"]',
              group: Shuffle.ALL_ITEMS
            });
          },
          // Set up button clicks
          setupFilters = function() {
            var $btns = $filterOptions.children();
            $btns.on("click", function(e) {
              e.preventDefault();
              var $this = $(this),
                isActive = $this.hasClass("active"),
                group = isActive ? "all" : $this.data("group");

              // Hide current label, show current label in title
              if (!isActive) {
                $(".portfolio-sorting li a").removeClass("active");
              }

              $this.toggleClass("active");

              // Filter elements
              $grid.shuffle("shuffle", group);
            });

            $btns = null;
          },
          // Re layout shuffle when images load. This is only needed
          // below 768 pixels because the .picture-item height is auto and therefore
          // the height of the picture-item is dependent on the image
          // I recommend using imagesloaded to determine when an image is loaded
          // but that doesn't support IE7
          listen = function() {
            var debouncedLayout = $.throttle(300, function() {
              $grid.shuffle("update");
            });

            // Get all images inside shuffle
            $grid.find("img").each(function() {
              var proxyImage;

              // Image already loaded
              if (this.complete && this.naturalWidth !== undefined) {
                return;
              }

              // If none of the checks above matched, simulate loading on detached element.
              proxyImage = new Image();
              $(proxyImage).on("load", function() {
                $(this).off("load");
                debouncedLayout();
              });

              proxyImage.src = this.src;
            });

            // Because this method doesn't seem to be perfect.
            setTimeout(function() {
              debouncedLayout();
            }, 500);
          };

        return {
          init: init
        };
      })(jQuery);

      if ($("#grid").length > 0) {
        shuffleme.init(); //filter portfolio
      }
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/products/Index.vue